import React from "react";
import useImage from "use-image";
import { Image } from "react-konva";
import { useDispatch, useSelector } from "react-redux";
import { calculateLandscapePlacement } from "../structurePlacementFunction/landscapeStructure";
import {
  calculatePortraitPlacement,
} from "../structurePlacementFunction/portraitStructure";
import { calculateCarportStructure } from "../structurePlacementFunction/doubleCarportPlacement";
import { calculateCustomizedStructure } from "../structurePlacementFunction/customizedStructure";
import { roofStructureData } from "../structureFunction";
import { calculatedStructure } from "../canvasFunction";
import { updateRoofDetails } from "../../../../Features/quantityInfo";
import {
  calMultipleStr,
} from "../structurePlacementFunction/smithStructure";

export default function URLImages({
  image,
  isSelected,
  onSelect,
  images,
  drag,
  check,
}) {
  const dispatch = useDispatch();
  const quantityInfo = useSelector((state) => state.quantity);
  const roofData = quantityInfo?.roofData || [];
  const roofIndex = quantityInfo.roofNo;
  const roofDetail = roofData[roofIndex];

  const [img] = useImage(image.src);

  const handleClick = () => {
    onSelect(image);
  };

  const handleDragEnd = (e) => {
    const updatedImage = {
      ...image,
      x: e.target.x(),
      y: e.target.y(),
    };

    const newImages = [...images];
    const indexToUpdate = newImages.findIndex(
      (img) => img.id === updatedImage.id
    );

    newImages[indexToUpdate] = updatedImage;

    dispatch(
      updateRoofDetails({
        index: quantityInfo.roofNo,
        fields: {
          images: newImages,
        },
      })
    );

    onSelect(updatedImage);

    const name = roofDetail.mountingStructure;
    const structureItem = roofStructureData.find((item) => item.name === name);

    if (roofDetail.structureType === "Multiple") {
      calMultipleStr(newImages, dispatch, roofDetail, quantityInfo);
    } else {
      const walkWayImages = roofDetail?.walkwayPlacement || [];
      if (
        structureItem.name === "Smith L1" ||
        structureItem.name === "Smith L2" ||
        structureItem.name === "Smith L3" ||
        structureItem.name === "Smith L2 Pro"
      ) {
        calculatedStructure({
          newImages,
          structureItem,
          dispatch,
          roofDetail,
          quantityInfo,
        });
      }
      // if (roofDetail.roofType === "Flat Roof") {
      //   calSmithStr(
      //     newImages,
      //     dispatch,
      //     roofDetail,
      //     quantityInfo,
      //     // imgDimension,
      //     // roofInfo,
      //     // panel,
      //     structureItem
      //   );
      // }
       else if (
        structureItem.name === "Smith Pro L" ||
        structureItem.name === "Smith Through Rail L"
      ) {
        calculateLandscapePlacement({
          newImages,
          walkWayImages,
          structureItem,
          dispatch,
          roofDetail,
          quantityInfo,
        });
      } else if (
        structureItem.name === "Smith Pro P" ||
        structureItem.name === "Smith Through Rail P"
      ) {
        calculatePortraitPlacement({
          newImages,
          walkWayImages,
          structureItem,
          dispatch,
          roofDetail,
          quantityInfo,
        });
      } else if (structureItem.roofType === "Carport") {
        calculateCarportStructure({
          newImages,
          structureItem,
          dispatch,
          roofDetail,
          quantityInfo,
        });
      } else if (structureItem.name === "Customized") {
        calculateCustomizedStructure({
          newImages,
          structureItem,
          dispatch,
          roofDetail,
          quantityInfo,
        });
      }
      // else if (structureItem.name === "Smith P1") {
      //   calculateP1Placement({
      //     newImages,
      //     dispatch,
      //     roofDetail,
      //     structureItem,
      //     quantityInfo,
      //   });
      // }
    }
  };

  return (
    <React.Fragment>
      <Image
        image={img}
        x={image.x}
        y={image.y}
        width={image.width}
        height={image.height}
        rotation={image?.angleDegree ? image.angleDegree : 0}
        draggable={check ? !drag : false}
        stroke={isSelected ? "green" : "transparent"}
        strokeWidth={isSelected ? 1 : 0}
        onClick={handleClick}
        onTap={handleClick}
        onDragEnd={handleDragEnd}
      />
    </React.Fragment>
  );
}
